/** Arrears follow-up (US-36): how a client was contacted, what came of it, and where a promise to pay stands. */

export const CONTACT_METHOD_LABELS: Record<string, string> = {
  PHONE: 'Phone call',
  WHATSAPP: 'WhatsApp',
  EMAIL: 'Email',
  SMS: 'SMS',
  VISIT: 'Visit',
  OTHER: 'Other',
};

export const CONTACT_OUTCOME_LABELS: Record<string, string> = {
  PROMISE_TO_PAY: 'Promise to pay',
  PAID: 'Says paid',
  CALL_BACK: 'Call back',
  NO_ANSWER: 'No answer',
  DISPUTE: 'Disputes amount',
  REFUSED_TO_PAY: 'Refused to pay',
  WRONG_NUMBER: 'Wrong number',
  OTHER: 'Other',
};

export const CONTACT_OUTCOME_COLORS: Record<string, string> = {
  PROMISE_TO_PAY: 'primary',
  PAID: 'success',
  CALL_BACK: 'info',
  NO_ANSWER: 'secondary',
  DISPUTE: 'warning',
  REFUSED_TO_PAY: 'danger',
  WRONG_NUMBER: 'dark',
  OTHER: 'secondary',
};

export const PROMISE_STATUS_LABELS: Record<string, string> = {
  PENDING: 'Pending',
  KEPT: 'Kept',
  BROKEN: 'Broken',
  REPLACED: 'Replaced',
};

export const PROMISE_STATUS_COLORS: Record<string, string> = {
  PENDING: 'warning',
  KEPT: 'success',
  BROKEN: 'danger',
  REPLACED: 'secondary',
};

export const contactMethodLabel = (code?: string | null): string =>
  (code && CONTACT_METHOD_LABELS[code]) || code || '';

export const contactOutcomeLabel = (code?: string | null): string =>
  (code && CONTACT_OUTCOME_LABELS[code]) || code || '';

export const promiseStatusLabel = (code?: string | null): string =>
  (code && PROMISE_STATUS_LABELS[code]) || code || '';
